<template>
  <div>
    <h3 class="header">{{title}}</h3>
    <h5 class="header">{{teacher}} ({{course}})</h5>
    <div class="title">
      <div style="font-size:12px;margin:10px;color:gray">{{desc}}</div>
      <van-cell-group style="font-size:32px;">
          <van-field label="姓名" size="large" clearable v-model="question.username" placeholder="请输入真实姓名" required/>
          <van-field label="部门" size="large" clearable v-model="question.dep" placeholder="请输入部门" required/>
          <van-field label="岗位" size="large" clearable v-model="question.postion" placeholder="请输入岗位" required/>
          <van-field label="手机" size="large" clearable v-model="question.mobile" placeholder="请输入联系方式" required/>
      </van-cell-group>
      
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>1.本次课程内容评价
        </h6>
        <div style="display:flex;margin:20px 0 0px 0;padding:0;">
          <van-cell-group>
            <div style="display:flex;">总体评价
             <van-rate v-model="question.radio1" style="margin-left:10px;"/></div>
            <div style="display:flex;">针对性强  <van-rate v-model="question.radio2"  style="margin-left:10px;"/></div>
            <div style="display:flex;">实践帮助 <van-rate v-model="question.radio3"  style="margin-left:10px;"/></div>
            <div style="display:flex;">预期效果 <van-rate v-model="question.radio4"  style="margin-left:10px;"/></div>
        </van-cell-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>2.{{teacher}}讲师评价
        </h6>
        <div style="display:flex;margin:20px 0 0px 0;padding:0;">
          <van-cell-group>
            <div style="display:flex;">总体评价 <van-rate v-model="question.radio5"  style="margin-left:10px;"/></div>
            <div style="display:flex;">解说能力  <van-rate v-model="question.radio6"  style="margin-left:10px;"/></div>
            <div style="display:flex;">专业程度 <van-rate v-model="question.radio7"  style="margin-left:10px;"/></div>
            <div style="display:flex;">主题逻辑 <van-rate v-model="question.radio8"  style="margin-left:10px;"/></div>
            <div style="display:flex;">授课案例 <van-rate v-model="question.radio9"  style="margin-left:10px;"/></div>
            <div style="display:flex;">课程氛围 <van-rate v-model="question.radio10"  style="margin-left:10px;"/></div>
        </van-cell-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>3.您对此次培训教学组织形式丶课堂纪律等培训软环境评价如何
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio11">
            <van-radio class="radio" name="4">非常满意</van-radio>
            <van-radio class="radio" name="3">满意</van-radio>
            <van-radio class="radio" name="2">基本满意</van-radio>
            <van-radio class="radio" name="1">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>4.您对此次培训时间安排评价如何
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio12">
            <van-radio class="radio" name="4">非常满意</van-radio>
            <van-radio class="radio" name="3">满意</van-radio>
            <van-radio class="radio" name="2">基本满意</van-radio>
            <van-radio class="radio" name="1">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <!-- <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">2.您认为此次内容是否具有针对性(适合我的需求)</h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;" v-model="question.multi">
            <div v-for="(item,index) in ite" :key="index">
              <van-radio class="radio" :name="index">{{item}}</van-radio>
            </div>
          </van-radio-group>
        </div>
      </div>-->
      <div>
        <h6>5.此次培训内容中,您认为对您最有启发的三个方面在哪里</h6>
        <van-cell-group>
          <van-field
            v-model="question.text1"
            style="border:1px solid #000000"
            type="textarea"
            rows="2"
            autosize
          />
        </van-cell-group>
      </div>
      <div>
        <h6>6.在上述三个方面中,您会马上去实施的是哪些方面</h6>
        <van-cell-group>
          <van-field
            v-model="question.text2"
            style="border:1px solid #000000"
            type="textarea"
            rows="2"
            autosize
          />
        </van-cell-group>
      </div>
      <div>
        <h6>7.如果有可能,您期望未来再展开哪些内容的培训</h6>
        <van-cell-group>
          <van-field
            v-model="question.text3"
            style="border:1px solid #000000"
            type="textarea"
            rows="2"
            autosize
          />
        </van-cell-group>
      </div>
      <div>
        <h6>8.为了能更好的提供优质培训服务,您对此次培训有什么评价和建议</h6>
        <van-cell-group>
          <van-field
            v-model="question.text4"
            style="border:1px solid #000000"
            type="textarea"
            rows="2"
            autosize
          />
        </van-cell-group>
      </div>
      <br />

      <div style="display:flex;justify-content: center;">
        <van-button type="primary" class="submit" @click="submitAnswer">提交答案</van-button>
      </div>
      <div class="footer">
        <br />
        {{customer}}
        <br />@锐道咨询
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      questions: "",
      desc: "",
      customer: "",
      question: {
        id: "",
        radio1: 5,
        radio2: 4,
        radio3: 4,
        radio4: 4,
        radio5: 5,
        radio6: 4,
        radio7: 5,
        radio8: 5,
        radio9: 5,
        radio10: 5,
        radio11: 4,
        radio12: 4,
        username: "",
        branch: "",
        dep: "",
        mobile: "",
        text4: "",
        text1: "",
        text2: "",
        text3: ""
      },

      course: "",
      teacher: ""
    };
  },
  methods: {
    submitAnswer() {
      if (
        this.question.username == "" ||
        this.question.position == "" ||
        this.question.dep == "" ||
        this.question.mobile == ""
      ) {
        this.$toast({
          message: "请填写完整信息",
          type: "waring"
        });
      } else if (
        this.question.radio1 == "" ||
        this.question.radio2 == "" ||
        this.question.radio3 == "" ||
        this.question.radio4 == "" ||
        this.question.radio5 == "" ||
        this.question.radio6 == "" ||
        this.question.radio7 == "" ||
        this.question.radio8 == "" ||
        this.question.radio9 == "" ||
        this.question.radio10 == "" ||
        this.question.radio11 == "" ||
        this.question.radio12 == ""
      ) {
        this.$toast({
          message: "请填写完整信息",
          type: "waring"
        });
      } else {
        
        this.$http
          .post("/oa/wxdianping/teacher_wenjuan", this.question)
          .then(res => {
            if (res.data.code == 200) {
              this.$toast({
                message: res.data.message,
                type: "success",
                duration: 300000
              });
              this.question = {};
              this.multi = [];
            } else {
              this.$toast({
                message: res.data.message,
                type: "waring",
                duration: 20000
              });
            }
          });
      }
    }
  },
  created() {
    document.title = "锐道咨询培训课后反馈";
    console.log(this.$route.query.id);
    if (this.$route.query.id) {
      this.question.id = this.$route.query.id;
      this.$http
        .post("/oa/wxdianping/teacher_index?id=" + this.question.id)
        .then(res => {
          this.course = res.data.data.course;

          this.title = res.data.data.title;
          this.customer = res.data.data.customer;
          this.teacher = res.data.data.teacher;
          this.$route.query.id = res.data.data.id;
        });
      // this.$http.get("/oa/wxzhuzi/multi_wenjuan?id=" + id).then(res => {

      // });
    } else {
      const id = 2;
      this.$http.post("/oa/wxdianping/teacher_index?id=" + id).then(res => {
        this.course = res.data.data.course;

        this.title = res.data.data.title;
        this.teacher = res.data.data.teacher;
        this.desc = res.data.data.desc;
        this.$route.query.id = res.data.data.id;
      });
      // this.$http.get("/oa/wxzhuzi/multi_wenjuan?id=" + id).then(res => {

      // });
    }
  }
};
</script>

<style scoped>
.title {
  width: 90%;
  margin: 0 0 0 20px;
  font-size: 16px;
}
.header {
  width: 100%;
  text-align: center;
  margin: 10px 0 0 0;
}
.radio {
  margin: 20px 0 0 0;
}
.submit {
  border-radius: 10px;

  width: 100px;
  height: 40px;
}
.margin {
  margin: 10px;
}
.footer {
  text-align: center;
  color: gray;
  font-size: 14px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/dynamic.vue